<script>
export default {
  
}
</script>

<template>
  <footer class="py-5 bg-light">
    <div class="container pt-4">
      <div class="row">
        <div class="col-md-8 mb-4">
          <h4 class=" mb-2">Katherine Watts Martinez Photography</h4>
          <div class="mb-1">
            <router-link class="text-decoration-none text-green" :to="{ name: 'home' }">Home</router-link>
          </div>
          <div class="mb-1">
            <router-link class="text-decoration-none text-green" :to="{ name: 'about' }">About us</router-link>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <h4 class="text-white mb-3">Follow us</h4>

        </div>
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="col-lg-12 pt-4">
          <p class="text-white">
            <small>Copyright &copy; Katherine Watts Martinez Photography 2019</small>
          </p>
        </div>
      </div>
    </div>
    <!-- /.container -->
  </footer>
</template>